import { tv } from './chunk-7NOFBOMW.js';
import { DateField, DateInput as DateInput$1, DateSegment } from 'react-aria-components';
import { jsx } from 'react/jsx-runtime';

var segmentStyles = tv({
  base: "type-literal:px-0 inline rounded px-0.5 caret-transparent outline outline-0",
  variants: {
    isPlaceholder: {
      true: "text-muted-foreground"
    },
    isFocused: {
      true: "bg-primary text-white"
    }
  }
});
var dateInputStyles = tv({
  base: [
    "border-input ring-offset-background placeholder:text-muted-foreground hover:bg-muted flex w-full items-center whitespace-nowrap rounded-lg border bg-transparent px-3 text-sm disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
    "focus-within:ring-ring focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2"
  ],
  variants: {
    size: {
      default: "h-10",
      sm: "h-9"
    },
    disabled: {
      true: "text-muted-foreground cursor-not-allowed opacity-50"
    },
    invalid: {
      true: "border-destructive"
    }
  },
  defaultVariants: {
    size: "default"
  }
});
function DateInput({
  className,
  size,
  invalid,
  disabled,
  ...restProps
}) {
  return /* @__PURE__ */ jsx(
    DateField,
    {
      isDisabled: disabled,
      isInvalid: invalid,
      ...restProps,
      className: dateInputStyles({ className, size, disabled, invalid }),
      children: /* @__PURE__ */ jsx(DateInput$1, { className: "w-full py-2", children: (segment) => /* @__PURE__ */ jsx(DateSegment, { segment, className: segmentStyles }) })
    }
  );
}

export { DateInput };
//# sourceMappingURL=chunk-N6UKSV55.js.map
//# sourceMappingURL=chunk-N6UKSV55.js.map